export const Lock = () => {
  return <>Hola</>
}